<template>
  <div>
    <base-label>{{ label }}</base-label>
    <div
      class="bg-white w-full flex items-center justify-between p-6 space-x-6 ps-mt-1"
    >
      <div class="flex-1 truncate">
        <div class="flex items-center space-x-3">
          <h3 class="text-gray-900 text-sm leading-5 font-medium truncate">
            {{ user.provided_name }}
          </h3>
        </div>
        <p class="mt-1 text-gray-500 text-sm leading-5 truncate">
          {{ timestamp }} ago from
          <span
            class="flex-shrink-0 inline-block px-2 py-0.5 text-teal-800 text-xs leading-4 font-medium bg-teal-100 rounded"
            >{{ source }}</span
          >
        </p>
      </div>
      <user-avatar class="w-10 h-10" :user="user" />
    </div>
  </div>
</template>

<script>
import BaseLabel from '@/components/forms/BaseLabel'
import UserAvatar from '@/components/UserAvatar'

export default {
  name: 'MetaDisplay',
  props: {
    label: String,
    timestamp: String,
    source: String,
    user: Object
  },
  components: {
    BaseLabel,
    UserAvatar
  }
}
</script>
